"use client"

import { useState } from "react"
import { Handle, Position } from "reactflow"
import NodeControls from "./NodeControls"
import "./Node.css"
import { Brain } from "lucide-react"

const AINode = ({ data, id }) => {
  const [expanded, setExpanded] = useState(false)
  const [model, setModel] = useState(data.model || "gpt-4")
  const [action, setAction] = useState(data.action || "Summarize text")
  const [prompt, setPrompt] = useState(
    data.prompt || "Summarize data, focus on affects to the hyperdrives and dampeners.",
  )

  const toggleExpand = () => {
    setExpanded(!expanded)
  }

  return (
    <div className={`custom-node ai-node ${expanded ? "expanded" : ""}`}>
      <NodeControls id={id} />

      <div className="node-header" onClick={toggleExpand}>
        <div className="node-icon">
          <Brain size={16} />
        </div>
        <div className="node-title">{data.label}</div>
      </div>

      {expanded && (
        <div className="node-content">
          <div className="node-field">
            <label>AI Provider</label>
            <select>
              <option>Retool AI</option>
              <option>OpenAI</option>
              <option>Anthropic</option>
            </select>
          </div>

          <div className="node-field">
            <label>Action</label>
            <select value={action} onChange={(e) => setAction(e.target.value)}>
              <option>Summarize text</option>
              <option>Generate content</option>
              <option>Analyze sentiment</option>
            </select>
          </div>

          <div className="node-field">
            <label>Input</label>
            <textarea value={prompt} onChange={(e) => setPrompt(e.target.value)} rows={3} />
          </div>

          <div className="node-field">
            <label>Model</label>
            <select value={model} onChange={(e) => setModel(e.target.value)}>
              <option value="gpt-4">gpt-4o</option>
              <option value="gpt-3.5">gpt-3.5-turbo</option>
              <option value="claude">claude-3</option>
            </select>
          </div>
        </div>
      )}

      {/* Input handle at the top-left */}
      <div className="input-handle-container">
        <Handle
          type="target"
          position={Position.Left}
          id="b"
          className="connection-handle input-handle"
          style={{
            left: "-15px",
            top: "0",
            transform: "translateY(50%)",
          }}
        />
      </div>

      {/* Output handle at the top-right */}
      <div className="output-handle-container">
        <Handle
          type="source"
          position={Position.Right}
          id="a"
          className="connection-handle output-handle"
          style={{
            right: "-15px",
            top: "0",
            transform: "translateY(50%)",
          }}
        />
      </div>
    </div>
  )
}

export default AINode
